import { Question } from "./question.model";

export class Section {
    public id: number;
    public title: string;
    public questions: Question[];
}
